export default "__VITE_ASSET__CXXCv$17__"